import { useState } from 'react';
import { flushSync } from 'react-dom';
import { TransactionsHistoryRequest, TransactionsHistoryResponse } from 'vopay';
import useFetchTransactionsHistory from '@/hooks/useApi/useFetchTransactionsHistory';

export default function useTransactionHistoryExport() {
  const { fetchTransactionsHistory } = useFetchTransactionsHistory();

  const [history, setHistory] = useState<TransactionsHistoryResponse>({
    Success: false,
    ErrorMessage: '',
    NumberOfRecords: 0,
    Transactions: [],
    PaginationMetaData: {
      TotalRecords: 0,
      Offset: 0,
      Limit: 20,
    },
  });

  async function getTransactionsHistory(args: TransactionsHistoryRequest) {
    const res = await fetchTransactionsHistory({
      ...args,
      Currency: args.Currency === 'All' ? undefined : args.Currency,
    });

    // the export function grabs the table data before it gets populated with history,
    // because react updates the dom AFTER all pending work is done.
    // flushSync forces React to flush any pending work and update the DOM synchronously
    flushSync(() => {
      setHistory(res);
    });

    return res;
  }
  return [history, getTransactionsHistory] as const;
}
